<script setup lang="ts">
    import { Checkbox } from '@/components/ui/checkbox';
    import { Label } from '@/components/ui/label';
    import { useI18n } from 'vue-i18n';

    const { t } = useI18n();

    const props = defineProps<{
        form: any;
    }>();

    const checkboxKeys = Object.keys(props.form.data());
</script>

<template>
    <div class="grid grid-cols-2 gap-3">
        <Label
            v-for="key in checkboxKeys"
            :key="key"
            class="flex flex-row items-center gap-2 font-normal"
        >
            <Checkbox
                :model-value="props.form[key] === 1"
                @update:model-value="(val) => (props.form[key] = val ? 1 : 0)"
            />
            <span>{{ t(`employees-optionals.table.${key}`) }}</span>
        </Label>
    </div>
</template>
